import React, { memo, useMemo, useState } from 'react'
import cn from 'classnames'
import { adminTabs } from './Tabs/adminTabs'
import styles from './SideBar.module.scss'
import { EUserRoles } from '../../enums/roles'
import { useLocation } from 'react-router'
import useCurrentTab from '../../hooks/useCurrentTab'
import { useUserRole } from '../../store/selectors/auth'
import { bossTabs } from './Tabs/bossTabs'
import { accountantTabs } from './Tabs/accountantTabs'
import { IconMenuLeftSquare } from '@utils/icons'
import { TabsUi } from '@components/ui/TabsUi/TabsUi'

const SideBar: React.FC = () => {
  const { pathname } = useLocation()
  const role = useUserRole()
  const activeTab = useCurrentTab(pathname, adminTabs)
  const [showMenu, setShowMenu] = useState(false)

  const showHandler = () => {
    setShowMenu((prev) => !prev)
  }

  const items = useMemo(() => {
    switch (role) {
      case EUserRoles.SUPER_ADMIN: {
        return adminTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
      case EUserRoles.BOSS: {
        return bossTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
      case EUserRoles.ACCOUNTANT: {
        return accountantTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
      }
      default:
        return bossTabs.map((el, index) => ({ label: <>{el.title}</>, key: String(index) }))
    }
  }, [role])

  return (
    <>
      <div className={cn(styles.sidebar, showMenu ? styles.active : '')}>
        <div className={styles.menu}>
          <p className={styles.subtitle}>Navigation</p>
          <TabsUi
            className={styles.tabs}
            tabPosition='left'
            defaultActiveKey='0'
            activeKey={String(activeTab)}
            items={items}
          />
        </div>
      </div>

      <div className={styles.mobileMenu}>
        <div className={styles.btn} onClick={showHandler}>
          <IconMenuLeftSquare width='20' height='20' fill='var(--color-main)' />
          Меню
        </div>
      </div>

      <div className={cn(styles.bg, showMenu ? styles.activeBg : '')} onClick={showHandler}></div>
    </>
  )
}

export default memo(SideBar)
